import { List, Record } from "immutable";
import { ProductProcessRecords, fromJSON } from "common/records/ProductProcess";
import { RootActions, RootState } from ".";
import { FETCH_PROCESSES, RECEIVE_PROCESSES, RECEIVE_PROCESS_ERRORS } from "common/reducers/productProcess.actions";

export const ProductProcessStateRecord = Record({
  processes: new ProductProcessRecords(),
});

export const initialState = ProductProcessStateRecord();
export type ProductProcessState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  let processes: ProductProcessRecords;
  switch (action.type) {
    case FETCH_PROCESSES:
      if (state.getIn(["productProcesses", "processes"])) {
        return state.setIn(["productProcesses", "processes", "loading"], true);
      }
      return state.setIn(["productProcesses", "processes"], fromJSON({ list: {}, loading: true }));
    case RECEIVE_PROCESSES:
      processes = fromJSON({ ...action.payload, loading: false });

      return state.setIn(["productProcesses", "processes"], processes);
    case RECEIVE_PROCESS_ERRORS:
      return state
        .setIn(["productProcesses", "processes", "errors"], List<string>(action.payload))
        .setIn(["productProcesses", "processes", "loading"], false);
    default:
      return state;
  }
};
